// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type GroupByIdQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.UserModelPublicBaseFilterInput> | PrivateSchemaTypes.UserModelPublicBaseFilterInput>;
  offset?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
  limit?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
}>;


export type GroupByIdQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { group?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'GroupModelAsAdmin' }
      & Pick<PrivateSchemaTypes.GroupModelAsAdmin, 'id' | 'name' | 'usersCount' | 'is_cpd'>
      & { users: Array<(
        { __typename?: 'UserModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.UserModelAsAdminQueries, 'id' | 'display_name' | 'userIdentity' | 'image_url'>
        & { userGroup?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UserGroupModel' }
          & Pick<PrivateSchemaTypes.UserGroupModel, 'role'>
        )>, groups: Array<(
          { __typename?: 'GroupModel' }
          & Pick<PrivateSchemaTypes.GroupModel, 'id' | 'name'>
        )> }
      )>, workspaces: Array<(
        { __typename?: 'WorkspaceModelAsCoordinator' }
        & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id' | 'name'>
      )>, scimResource?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'ScimResourceModel' }
        & Pick<PrivateSchemaTypes.ScimResourceModel, 'id' | 'external_id'>
      )> }
    )> }
  )> }
);

export type UserChangeGroupRoleMutationVariables = PrivateSchemaTypes.Exact<{
  groupId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
  role: PrivateSchemaTypes.UserGroupRoleEnum;
}>;


export type UserChangeGroupRoleMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { user?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.UserModelAsAdminMutations, 'id'>
      & { setGroupRole?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserGroupModel' }
        & Pick<PrivateSchemaTypes.UserGroupModel, 'role'>
      )> }
    )> }
  )> }
);

export type AddUserToGroupMutationVariables = PrivateSchemaTypes.Exact<{
  groupId: PrivateSchemaTypes.Scalars['PositiveInt'];
  userId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddUserToGroupMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { user?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.UserModelAsAdminMutations, 'id'>
      & { addToGroup?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'UserGroupModel' }
        & Pick<PrivateSchemaTypes.UserGroupModel, 'created_at'>
      )> }
    )> }
  )> }
);


export const GroupByIdDocument = gql`
    query groupById($id: PositiveInt!, $filters: [UserModelPublicBaseFilterInput!], $offset: NonNegativeInt, $limit: NonNegativeInt) {
  admin {
    group(id: $id) {
      id
      name
      usersCount(filters: $filters)
      is_cpd
      users(
        filters: $filters
        offset: $offset
        limit: $limit
        order: {name: "display_name"}
      ) {
        id
        display_name
        userIdentity
        image_url
        userGroup(id: $id) {
          role
        }
        groups {
          id
          name
        }
      }
      workspaces {
        id
        name
      }
      scimResource {
        id
        external_id
      }
    }
  }
}
    `;

/**
 * __useGroupByIdQuery__
 *
 * To run a query within a React component, call `useGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGroupByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupByIdQuery, GroupByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupByIdQuery, GroupByIdQueryVariables>(GroupByIdDocument, options);
      }
export function useGroupByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupByIdQuery, GroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupByIdQuery, GroupByIdQueryVariables>(GroupByIdDocument, options);
        }
export type GroupByIdQueryHookResult = ReturnType<typeof useGroupByIdQuery>;
export type GroupByIdLazyQueryHookResult = ReturnType<typeof useGroupByIdLazyQuery>;
export type GroupByIdQueryResult = Apollo.QueryResult<GroupByIdQuery, GroupByIdQueryVariables>;
export const UserChangeGroupRoleDocument = gql`
    mutation userChangeGroupRole($groupId: PositiveInt!, $userId: PositiveInt!, $role: UserGroupRoleEnum!) {
  admin {
    user(id: $userId) {
      id
      setGroupRole(groupId: $groupId, role: $role) {
        role
      }
    }
  }
}
    `;
export type UserChangeGroupRoleMutationFn = Apollo.MutationFunction<UserChangeGroupRoleMutation, UserChangeGroupRoleMutationVariables>;

/**
 * __useUserChangeGroupRoleMutation__
 *
 * To run a mutation, you first call `useUserChangeGroupRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeGroupRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeGroupRoleMutation, { data, loading, error }] = useUserChangeGroupRoleMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserChangeGroupRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserChangeGroupRoleMutation, UserChangeGroupRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserChangeGroupRoleMutation, UserChangeGroupRoleMutationVariables>(UserChangeGroupRoleDocument, options);
      }
export type UserChangeGroupRoleMutationHookResult = ReturnType<typeof useUserChangeGroupRoleMutation>;
export type UserChangeGroupRoleMutationResult = Apollo.MutationResult<UserChangeGroupRoleMutation>;
export type UserChangeGroupRoleMutationOptions = Apollo.BaseMutationOptions<UserChangeGroupRoleMutation, UserChangeGroupRoleMutationVariables>;
export const AddUserToGroupDocument = gql`
    mutation addUserToGroup($groupId: PositiveInt!, $userId: PositiveInt!) {
  admin {
    user(id: $userId) {
      id
      addToGroup(groupId: $groupId) {
        created_at
      }
    }
  }
}
    `;
export type AddUserToGroupMutationFn = Apollo.MutationFunction<AddUserToGroupMutation, AddUserToGroupMutationVariables>;

/**
 * __useAddUserToGroupMutation__
 *
 * To run a mutation, you first call `useAddUserToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToGroupMutation, { data, loading, error }] = useAddUserToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddUserToGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToGroupMutation, AddUserToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToGroupMutation, AddUserToGroupMutationVariables>(AddUserToGroupDocument, options);
      }
export type AddUserToGroupMutationHookResult = ReturnType<typeof useAddUserToGroupMutation>;
export type AddUserToGroupMutationResult = Apollo.MutationResult<AddUserToGroupMutation>;
export type AddUserToGroupMutationOptions = Apollo.BaseMutationOptions<AddUserToGroupMutation, AddUserToGroupMutationVariables>;